define([], () => {
    return ['LocaleService', '$filter', (LocaleService, $filter) => {
        function getCurrency({currency}) {
            return angular.isDefined(currency) ? LocaleService.getCurrencySymbol(currency) : LocaleService.getLocaleInfo().currency.symbol;
        }

        return (amount) => {
            if (amount) {
                if (amount.amount) {
                    return $filter('currency')(
                        amount.amount,
                        getCurrency(amount)
                    );
                }
                if (typeof amount === 'number') {
                    return $filter('currency')(amount, '');
                }
                if (typeof amount === 'string') {
                    return getCurrency(amount);
                }
            }
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/filters/BaslerCurrencyFilter.js